import './crispChatWrapper';

// CALLRAIL - Dynamic phone number swap for call tracking
function setEl() {
  var element = document.createElement('script');
  element.type = 'text/javascript';
  element.async = true;
  element.src = '//cdn.callrail.com/companies/150039341/a241d8687f3c405c8e85/12/swap.js';
  var otherEl = document.getElementsByTagName('script')[0];
  otherEl.parentNode.insertBefore(element, otherEl);
}

function timeoutFunc() {
  setTimeout(setEl, 1000);
}

window.addEventListener('scroll', timeoutFunc, { once: true });

if (!window.ga && window['env'] !== 'development' && window.current_user && !window.current_user.isWyIp) {
  console.info('This user may have blocked ga🗯');
}

if (window.wyTrackingDisabled) {
  console.info('This user may have an ad-blocker🤔');
}
